"use strict";
// tslint:disable
// eslint-disable
/**
 * API Key Management API
 * API for CRUDing API Keys
 *
 * The version of the OpenAPI document: 1.0.3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var runtime_1 = require("../runtime");
var _1 = require("./");
function ErrorResponseFromJSON(json) {
    return ErrorResponseFromJSONTyped(json, false);
}
exports.ErrorResponseFromJSON = ErrorResponseFromJSON;
function ErrorResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    if (!ignoreDiscriminator) {
        if (json['code'] === 'ErrorResponseInvalidSecret') {
            return _1.ErrorResponseInvalidSecretFromJSONTyped(json, true);
        }
        if (json['code'] === 'ErrorResponseInsufficientRights') {
            return _1.ErrorResponseInsufficientRightsFromJSONTyped(json, true);
        }
        if (json['code'] === 'ErrorResponseMissingField') {
            return _1.ErrorResponseMissingFieldFromJSONTyped(json, true);
        }
        if (json['code'] === 'ErrorResponseNameTaken') {
            return _1.ErrorResponseNameTakenFromJSONTyped(json, true);
        }
        if (json['code'] === 'ErrorResponseNameTooLong') {
            return _1.ErrorResponseNameTooLongFromJSONTyped(json, true);
        }
        if (json['code'] === 'ErrorResponseNotFound') {
            return _1.ErrorResponseNotFoundFromJSONTyped(json, true);
        }
        if (json['code'] === 'ErrorResponseDeleted') {
            return _1.ErrorResponseDeletedFromJSONTyped(json, true);
        }
        if (json['code'] === 'ErrorResponseTokenLimitReached') {
            return _1.ErrorResponseTokenLimitReachedFromJSONTyped(json, true);
        }
        if (json['code'] === 'ErrorInvalidPageSize') {
            return _1.ErrorInvalidPageSizeFromJSONTyped(json, true);
        }
        if (json['code'] === 'ErrorInvalidSortColumn') {
            return _1.ErrorInvalidSortColumnFromJSONTyped(json, true);
        }
    }
    return {
        'error': !runtime_1.exists(json, 'error') ? undefined : json['error'],
        'message': !runtime_1.exists(json, 'message') ? undefined : json['message'],
        'code': !runtime_1.exists(json, 'code') ? undefined : json['code'],
    };
}
exports.ErrorResponseFromJSONTyped = ErrorResponseFromJSONTyped;
function ErrorResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'error': value.error,
        'message': value.message,
        'code': value.code,
    };
}
exports.ErrorResponseToJSON = ErrorResponseToJSON;
/**
* @export
* @enum {string}
*/
var ErrorResponseCodeEnum;
(function (ErrorResponseCodeEnum) {
    ErrorResponseCodeEnum["INVALIDSECRET"] = "API_KEY.INVALID_SECRET";
    ErrorResponseCodeEnum["INSUFFICIENTRIGHTS"] = "API_KEY.INSUFFICIENT_RIGHTS";
    ErrorResponseCodeEnum["MISSINGFIELD"] = "API_KEY.MISSING_FIELD";
    ErrorResponseCodeEnum["APIKEYNAMETAKEN"] = "API_KEY.API_KEY.NAME_TAKEN";
    ErrorResponseCodeEnum["NAMETOOLONG"] = "API_KEY.NAME_TOO_LONG";
    ErrorResponseCodeEnum["NOTFOUND"] = "API_KEY.NOT_FOUND";
    ErrorResponseCodeEnum["TOKENDELETED"] = "API_KEY.TOKEN_DELETED";
    ErrorResponseCodeEnum["TOKENLIMITREACHED"] = "API_KEY.TOKEN_LIMIT_REACHED";
    ErrorResponseCodeEnum["INVALIDPAGESIZE"] = "API_KEY.INVALID_PAGE_SIZE";
    ErrorResponseCodeEnum["INVALIDSORTCOLUMN"] = "API_KEY.INVALID_SORT_COLUMN";
})(ErrorResponseCodeEnum = exports.ErrorResponseCodeEnum || (exports.ErrorResponseCodeEnum = {}));
